import React from 'react';
import { Tooltip } from '@mui/material';
import { revertPositionTitleV2 } from 'shared-utils';
import { ActiveCompaniesDocument } from 'types';

const CandidateActiveCompanies = ({
	activeCompanies,
	offerRolledOutCompany,
}: {
	activeCompanies: ActiveCompaniesDocument[];
	offerRolledOutCompany?: string[];
}) => {
	return (
		<div className="flex flex-col gap-1 text-[#555770]">
			{activeCompanies.length ? (
				<Tooltip
					title={
						<div className="text-center">
							{activeCompanies
								?.slice(2, activeCompanies?.length)
								?.map(company => `${company?.companyName} - ${revertPositionTitleV2(company?.positionTitle)}`)
								?.join(', ')}
						</div>
					}
					arrow
					placement="bottom"
					{...(activeCompanies?.length > 2 ? {} : { open: false })}
				>
					<div>
						{activeCompanies?.slice(0, 2).map((activeCompany: ActiveCompaniesDocument, index: number) => (
							<p key={index} className="font-inter text-xs font-medium ">
								{activeCompany?.companyName} - {revertPositionTitleV2(activeCompany?.positionTitle)}
								{offerRolledOutCompany?.includes(activeCompany?.companyId) ? (
									<span className="text-green-500 whitespace-pre"> (Offer Rolled Out)</span>
								) : (
									''
								)}
								<span className="last-of-type:hidden">,</span>
							</p>
						))}
						{activeCompanies?.length > 2 && <p className="underline">+{activeCompanies?.length - 2} more</p>}
					</div>
				</Tooltip>
			) : (
				<p className="text-center"> - </p>
			)}
		</div>
	);
};

export default CandidateActiveCompanies;
